<template>
	<Layout>
		<div  style="width: 100%">
			<div class="index-page">
				<div data-am-widget="tabs" class="am-tabs am-tabs-default">
					<div class="am-tabs-bd">
						<div
							class="am-tab-panel am-active"
							v-if="slideshow.length > 0"
							:style="{ backgroundImage: `url(${slideshow[tabIndex].imageUrl})`}">
							<div class="index-banner">
								<div class="index-mask">
									<div class="container">
										<div class="am-g">
											<div class="am-u-md-10 am-u-sm-centered" style="text-align: center">
												<h1 class="slide_simple--title">One -stop global collection solution</h1>
												<p class="slide_simple--text am-text-left" style="display: flex;justify-content: center">
                          Easily get the localization of payment.
                          <br>
                          The payment method is diversified, the payment success rate is higher.
                          <br>
                          Simple technical access, more convenient transaction management.
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<ul  class="am-tabs-nav am-cf index-tab">
						<li v-for="(tab,index) in tabList" :key="index" :class="tabIndex === index ? 'am-active':''" >
							<a href="#" @click.prevent="changeTab(index)">
								<div class="am-u-md-3 am-u-sm-3 am-padding-right-0">
									<i :class="tab.icon"></i>
								</div>
								<div class="school-item-right am-u-md-9 am-u-sm-9 am-text-left">
									<strong class="promo_slider_nav--item_title">{{tab.name}}</strong>
									<p class="promo_slider_nav--item_description">{{tab.desc}}</p>
								</div>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="section">
			<div class="container" style="max-width: 1160px;">
				<div class="section--header">
					<h2 class="section--title">Payment localization</h2>
					<p class="section--description">
            Payment methods are diversified, and users can choose the local payment method that they are most familiar with and trust.
            <br>
            Better payment experience, better payment success rate, and 30% increase in transaction volume
					</p>
				</div>

				<div v-if="false" class="index-container">
					<div class="am-g">
						<div class="am-u-md-3" v-for="(advantage,index) in advantageList" :key="index">
							<div class="features_item">
								<img :src="advantage.cover" alt="">
								<h3 class="features_item--title">{{advantage.title}}</h3>
								<p class="features_item--text">{{advantage.desc}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

    <div class="section">
			<div class="container" style="max-width: 1160px;">
				<div class="section--header">
					<h2 class="section--title">No passage fee, no annual fee</h2>
					<p class="section--description">
            No annual fee, monthly fee, channel fee, no transaction, no fee.
            <br>
            Support for multi-currency transactions with shorter settlement cycle
					</p>
				</div>

				<div v-if="false" class="index-container">
					<div class="am-g">
						<div class="am-u-md-3" v-for="(advantage,index) in advantageList" :key="index">
							<div class="features_item">
								<img :src="advantage.cover" alt="">
								<h3 class="features_item--title">{{advantage.title}}</h3>
								<p class="features_item--text">{{advantage.desc}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="section" style="border-bottom: 1px solid #e9e9e9; padding-top: 0">
			<div class="container" style="max-width: 1160px;">
				<div class="section--header">
					<h2 class="section--title">Developer friendly</h2>
					<p class="section--description">
            Fully support web and mobile payment.
            <br>
            Both the website and the mobile APP can easily access the API interface of AiruiPay.
					</p>
				</div>

				<div v-if="false" class="index-container">
					<div class="am-g">
						<div class="am-u-md-3" v-for="(service,index) in serviceList" :key="index">
							<div class="service_item">
								<i class="service_item--icon" :class="service.icon"></i>
								<h3 class="service_item--title">{{ service.title }}</h3>
								<div class="service_item--text"><p>{{service.desc}}</p></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from "@/components/common/Layout";
export default {
	name: "IndexView",
	components: {Layout},
	data(){
		return{
			tabList:[
				{name:'Web Pay', desc:'Online website payment', icon:'am-icon-cog'},
				{name:'Phone Pay', desc:'Mobile app payment', icon:'am-icon-lightbulb-o'},
				{name:'Cross-border Pay', desc:'Transnational network payment', icon:'am-icon-line-chart'},
				{name:'About ', desc:'introduction', icon:'am-icon-hourglass-end'},
			],
			tabIndex: 0,
			slideshow:[
          {
        imageUrl: require('../assets/images/index/banner1.webp')
        },
        {
          imageUrl: require('../assets/images/index/page_bg3.jpg')
        },
        {
          imageUrl: require('../assets/images/index/page_bg4.jpg')
        },
        {
          imageUrl: require('../assets/images/index/f01.jpg')
        }
      ],

			advantageList:[
				{id:1,cover:require('../assets/images/index/f01.jpg'),title:'简单的适配过程',desc:'用户可快速学习适配开发，通过丰富的组件库完成页面功能的移动化适配。'},
				{id:2,cover:require('../assets/images/index/f01.jpg'),title:'简单的适配过程',desc:'用户可快速学习适配开发，通过丰富的组件库完成页面功能的移动化适配。'},
				{id:3,cover:require('../assets/images/index/f01.jpg'),title:'简单的适配过程',desc:'用户可快速学习适配开发，通过丰富的组件库完成页面功能的移动化适配。'},
				{id:4,cover:require('../assets/images/index/f01.jpg'),title:'简单的适配过程',desc:'用户可快速学习适配开发，通过丰富的组件库完成页面功能的移动化适配。'},
			],
			serviceList:[
				{id:1,icon:'am-icon-diamond',title:'多页面工作',desc:'标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'},
				{id:2,icon:'am-icon-user',title:'多页面工作',desc:'标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'},
				{id:3,icon:'am-icon-umbrella',title:'多页面工作',desc:'标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'},
				{id:4,icon:'am-icon-briefcase',title:'多页面工作',desc:'标签栏可切换，不必为了新内容而被迫跳转界面，多项工作内容并行处理'}
			]
		}
	},
	mounted() {
		this.getSlideshow()
	},
	methods:{
		changeTab(index){
			this.tabIndex = index
		},
		getSlideshow(){
			this.getRequest("/findAllSlideshow").then(resp =>{
				if (resp){
					// this.slideshow = resp.data.data
					//console.log(this.slideshow)
				}
			})
		}
	},
}
</script>

<style scoped>

</style>
